module.exports = __webpack_public_path__ + "img/plus-circle.824fbc96.svg";